import React from "react";

const ScreeningContext = React.createContext({
  screeningData: {},
  setScreeningData: async () => {},
});

export { ScreeningContext };
